import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {Drawer, Tabs, Input,Select} from 'antd';
import DynamicForm from "../DynamicForm";
import moment from 'moment';
import { Form, Button, DatePicker, InputNumber } from 'antd';
const {TabPane} = Tabs;
import apiProxy from "../../stores/APIProxy";
import {klicountry,projectTitle,getWorkflow,klicountrynames,getTask,getcbdcountrynames} from '../../stores/APIEndpoints';
import looseLeafStore from "../../stores/LooseLeafStore"
import './../../index.css';
import {appStore} from '../../stores/AppStore';
import '../../../src/index.css';
import { NonceProvider } from 'react-select';
import LooseLeafSchedulerDrawer from "./LooseLeafScheduleDrawer";
import LooseLeafPeopleDrawer from "./LooseLeafPeopleDrawer";


@inject('looseLeafStore')
@observer
class LooseLeafDrawer extends Component {
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        const data = this.store.looseLeafSeed;
        this.state = {
            activeTabState:"0",
            selectDates:[],
            selectWorkflow:'',
            selectCountry:'',
            selectTasks:'',
            fieldDefs : [
            {
                key: "titleId",
                label: "Title",
                type: "dropdown",
                options: [],
                defaultValue: data.titleId,
                required: true,
                disabled: data.titleId
            }, {
                key: "countryId",
                label: "Country",
                type: "dropdown",
                options: [],
                defaultValue: data.countryId,
                disabled: data.countryId,
                onChange:this.countryChange.bind(this,1),
                required: true
            },
            {
                key: "classification",
                label: "Document Name",
                type: "text",
                defaultValue: data.docname,
            },
            // {
            //     key: "classification",
            //     label: "Classification",
            //     type: "dropdown",
            //     options: [
            //         {label: 'Book', value: 'Book'},
            //         {label: 'Journal', value: 'Journal'},
            //         {label: 'Loose leaf', value: 'Loose leaf'},
            //     ],
            //     defaultValue: data.classification,
            //     disabled: data.titleId
            // },
             {
                key: "leafType",
                label: "Leaf Type",
                type: "dropdown",
                options: [
                    {label: 'Print/Online', value: 'Print/Online'},
                    {label: 'Online', value: 'Online'},
                ],
                defaultValue: data.leafType,
                disabled: data.titleId
            }],
            editFieldDefs : [
              
                {
                key: "titleId",
                label: "Title",
                type: "dropdown",
                options: [
                    {label: 'IEADA', value: 498},
                    {label: 'MIP', value: 1293},
                    {label: 'TEST', value: 491},
                ],
                defaultValue: data.titleId,
                disabled: data.titleId
            },{
                key: "lapsId",
                label: "LAPS ID",
                type: "text",
                defaultValue: data.lapsId,
            },
            {
                key: "publishoneId",
                label: "PublishOne ID",
                type: "text",
                defaultValue: data.publishoneId,
            },
            {
                key: "version",
                label: "Version",
                type: "text",
                defaultValue: data.version,
            }, {
                key: "countryId",
                label: "Country",
                "toolTip": "The country of the Loose Leaf",
                type: "dropdown",
                options: [],
                defaultValue: data.countryId,
                disabled: data.countryId,
                onChange:this.countryChange.bind(this,3),
            },
            {
                key: "classification",
                label: "Document Name",
                type: "text",
                defaultValue: data.docname,
             },
             //{
            //     key: "classification",
            //     label: "Classification",
            //     type: "dropdown",
            //     options: [
            //         {label: 'Book', value: 'Book'},
            //         {label: 'Journal', value: 'Journal'},
            //         {label: 'Loose leaf', value: 'Loose leaf'},
            //     ],
            //     defaultValue: data.classification,
            //     disabled: data.titleId
            // }, 
            {
                key: "leafType",
                label: "Leaf Type",
                type: "dropdown",
                options: [
                    {label: 'Print/Online', value: 'Print/Online'},
                    {label: 'Online', value: 'Online'},
                ],
                defaultValue: data.leafType,
                disabled: data.titleId
            }],
            schedulefieldDefs : [
                {
                    key: "globalWorkflowId",
                    label: "Workflow",
                    type: "dropdown",
                    options: [],
                    defaultValue:data.globalWorkflowId,
                    disabled: false,
                },
                // {
                //     mode:"multiple",
                //     key: "reseedType",
                //     label: "Reseed Type",
                //     type: "dropdown",
                //     options: [
                //         {label: 'BASED ON', value: 'BASEDON'},
                //         {label: 'FIXED', value: 'FIXED'},
                //     ],
                //     defaultValue:data.reseedType,
                //     disabled: false,
                //     onChange:this.getReSeedType,
                // },
                // {
                //     label: "Reseed Fixed Dates",
                //     key: "reseedFixedDates",
                //     type: "text",
                //     defaultValue:data.reseedFixedDates,
                //     disabled: false,
                // },
                // {
                    
                //     label:'date',
                //     key: "reseedFixedDatesSelect",
                //     type: "date",
                //     defaultValue:0,
                //     disabled: false,
                  
                // },
                // {
                //     key: "abstractTaskId",
                //     label: "Abstract Tasks",
                //     type: "dropdown",
                //     options: [],
                //     defaultValue:data.abstractTaskId,
                //     disabled: false,
                // },
                {
                    key: "recyclePeriod",
                    label: "Recycle Period",
                    type: "number",
                    defaultValue: data.recyclePeriod,
                    disabled: false,
                    onChange:this.dateSelected,
                },
                
                {
                    key: "projectStartDate",
                    label: "Request Date",
                    type: "date",
                    defaultValue: data.projectStartDate,
                    disabled: false,
                   
                },
                {
                    key: "filesToAuthorDate",
                    label: "Send files to author on",
                    type: "date",
                    defaultValue: data.filesToAuthorDate,
                    disabled: false,
                },
                {
                    key: "filesFromAuthorDate",
                    label: "Expect files from author on",
                    type: "date",
                    defaultValue: data.filesFromAuthorDate,
                    disabled: false,
                   
                },
                {
                    key: "ifpDate",
                    label: "IFP Date",
                    type: "date",
                    defaultValue: data.ifpDate,
                    disabled: false,
                   
                },
                {
                    key: "cmpDate",
                    label: "CMP Date",
                    type: "date",
                    defaultValue: data.cmpDate,
                    disabled: false,
                   
                }
               
            ]
      }
    }
    get store() {
        return looseLeafStore;
      
    }
    async componentDidMount() {
        this.populatecountry();
        this.createpopulatecountry();
        this.populatetitle();
        this.createpopulatetitle();
       // this.getWorkflowList();
       // this.getTaskList();
      }
      getReSeedType = (value) =>{
        const {schedulefieldDefs, selectDates} = this.state;
         if(value == "BASEDONATASK")
         {
            schedulefieldDefs[2].disabled = false;
            schedulefieldDefs[3].disabled = true;
            schedulefieldDefs[4].disabled = false;
            schedulefieldDefs[5].disabled = false;
         }
         else
         {
            schedulefieldDefs[2].disabled = false;
            schedulefieldDefs[3].disabled = false;
            schedulefieldDefs[4].disabled = true;
            schedulefieldDefs[5].disabled = true;
         }
      }
      dateSelected = () => {
        const {schedulefieldDefs, selectDates} = this.state;
      
        this.setState({selectDates: selectDates.push(value.toString())});
        
        schedulefieldDefs[2].defaultValue = selectDates;
    }
      setFilterOptions = (index, options) => {
        this.setState(state => {
          const fieldDefs = [...state.fieldDefs];
          fieldDefs[index].options = options;
          fieldDefs[index].loadingOptions = false;
          return {
            ...state,
            fieldDefs,
          };
        });
      };
      setFiltereditOptions = (index, options) => {
        this.setState(state => {
          const editFieldDefs = [...state.editFieldDefs];
          editFieldDefs[index].options = options;
          editFieldDefs[index].loadingOptions = false;
          return {
            ...state,
            editFieldDefs,
          };
        });
      };
      setFilterworkflowOptions = (index, options) => {
          if(index == 0)
          {
              appStore.getWorkFlow=options;
          }
        this.setState(state => {
            const schedulefieldDefs = [...state.schedulefieldDefs];
            schedulefieldDefs[index].options = options;
            schedulefieldDefs[index].loadingOptions = false;
            return {
              ...state,
              schedulefieldDefs,
            };
          });
      }
     
      countryChange =async(value, index)=>{
        const bodyParams = {
            "where": {id: value.toString()},
            "limit": "5"
      }
        let response = await this.apiProxy.asyncPost(klicountrynames, bodyParams);
        const option = await response.json();
        looseLeafStore.getCountryName=option[0].country;
        //   if(value == 2)
        //   {
        //     const getCountryName = this.state.fieldDefs;
        //    
        //     looseLeafStore.getCountryName =getCountryName[value].options[(index-1)].name;
        //   }
        //   else
        //   {
        //     const getCountryName = this.state.editFieldDefs;
        //    
        //     looseLeafStore.getCountryName =getCountryName[value].options[(index-1)].name;
        //   }
      }
      populatecountry = async () => {
        const bodyParams = {
            "where": {},
        }
        let response = await this.apiProxy.asyncPost(getcbdcountrynames, bodyParams);

        const option = await response.json();
      
        this.setFiltereditOptions(3, option.map(t => ({
          name:t.name,
          label: t.name,
          value: t.id
        })));
      };
     createpopulatecountry = async () => {
        const bodyParams = {
            "where": {},
        }
        let response = await this.apiProxy.asyncPost(getcbdcountrynames, bodyParams);
        const option = await response.json();
        this.setState({selectCountry:option});
        this.setFilterOptions(1, option.map(t => ({
          name:t.name,
          label: t.name,
          value: t.id
        })));
      };
      populatetitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        this.setFiltereditOptions(0, option.map(t => ({
          name: t.shortTitle,
          label: t.shortTitle,
          value: t.id
        })));
      };
      getWorkflowList = async () => {
        const bodyParams = {
            "where": {},
        }
        let response = await this.apiProxy.asyncPost(getWorkflow, bodyParams);
        const option = await response.json();
        this.setState({selectWorkflow:option});
        this.setFilterworkflowOptions(0, option.map(t => ({
          name: t.name,
          label: t.name,
          value: t.id
        })));
      };
      getTaskList = async() =>{
        const bodyParams = {
            "where": {},
        }
        let response = await this.apiProxy.asyncPost(getTask, bodyParams);
        const option = await response.json();
        this.setState({selectTasks:option});
        this.setFilterworkflowOptions(3, option.map(t => ({
          name: t.name,
          label: t.name,
          value: t.id
        })));
        
      }
     createpopulatetitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        this.setFilterOptions(0, option.map(t => ({
          name: t.shortTitle,
          label: t.shortTitle,
          value: t.id
        })));
      };

    render() {
        if (!this.props.visible) return null;

        const store = this.store;
        const title = store.looseLeafSeed.id === undefined ? "New Title" : store.looseLeafSeed.abbreviation + " - " + store.looseLeafSeed.country;
        return (
            <Drawer
                title={title} closable={true}
                onClose={this.onClose}
                width={"40%"}
                visible={this.props.visible}
                destroyOnClose={true}>
                {this.renderTabs()}
            </Drawer>
        )
    }
   
    onClose = () => {
        this.store.setDrawerVisible(false);
        this.store.looseLeafSeed = {};
    };

    onChangeTab = activeTab => {
        //this.setState({"activeTabState":looseLeafStore.activeKey});
        this.store.activeTab = activeTab;
        console.log(`${this.store.activeTab}`);
    };
 
    renderTabs = () => {
       
        return (
            <Tabs
                activeKey={`${this.store.activeTab}`}
                tabPosition='top'
                onChange={this.onChangeTab}>
                {this.renderPrimaryInfoForm()}
                {this.renderPeopleForm()}
                {this.renderScheduleForm()}
            </Tabs>
        );
    };

    renderPrimaryInfoForm =  () => {
        const data = this.store.looseLeafSeed;
        const { fieldDefs, editFieldDefs } = this.state;
        if(this.store.rowclick == false)
        {
            editFieldDefs[0].defaultValue = data.titleId;
            editFieldDefs[1].defaultValue = data.lapsId;
            editFieldDefs[2].defaultValue = data.version;
            editFieldDefs[3].defaultValue = data.countryId;
            editFieldDefs[4].defaultValue = data.classification;;
           // editFieldDefs[5].defaultValue = data.classification;
            editFieldDefs[5].defaultValue = data.leafType;
            editFieldDefs[6].defaultValue = data.publishoneId;
            return (
                <TabPane tab={'Primary Information'} key={"0"}>
                    <DynamicForm
                        items={editFieldDefs}
                        onSubmit={data => this.store.createNewSeed(data)}
                        submitButtonText={'Save and Next'}
                        submitButtonProps={{loading: this.store.formLoading}}
                        strictValidation={!data.id}
                    />
                </TabPane>
            );
           
        }
        else
        {
            fieldDefs[0].defaultValue = data.titleId;
            fieldDefs[1].defaultValue = data.countryId;
            fieldDefs[2].defaultValue = data.classification;
           // fieldDefs[3].defaultValue = data.classification;
            fieldDefs[3].defaultValue = data.leafType;
            return (
                <TabPane tab={'Primary Information'} key={"0"}>
                    <DynamicForm
                        items={fieldDefs}
                        onSubmit={data => this.store.createNewSeed(data)}
                        submitButtonText={'Save and Next'}
                        submitButtonProps={{loading: this.store.formLoading}}
                        strictValidation={!data.id}
                    />
                </TabPane>
            );
           
        }
   
    };

    renderPeopleForm = () => {
        const data = this.store.looseLeafSeed;
        const fieldDefs = [{
            key: "authorEmails",
            label: "Author Emails",
            type: "text",
            defaultValue: data.authorEmails,
            disabled: false
        }, {
            key: "authorNames",
            label: "Author Names",
            type: "text",
            defaultValue: data.authorNames,
            disabled: false
        }, {
            key: "cmEmails",
            label: "CM Emails",
            type: "text",
            defaultValue: data.cmEmails,
            disabled: false
        }, {
            key: "cmNames",
            label: "CM Names",
            type: "text",
            defaultValue: data.cmNames,
            disabled: false
        }, {
            key: "editorEmails",
            label: "Editor Emails",
            type: "text",
            defaultValue: data.editorEmails,
            disabled: false
        }, {
            key: "editorNames",
            label: "Editor Names",
            type: "text",
            defaultValue: data.editorNames,
            disabled: false
        }];

        return (
            <TabPane tab={'People'} key={"1"} disabled={!data.id}>
                {/* <LooseLeafPeopleDrawer dataStore={data}></LooseLeafPeopleDrawer> */}
                {/* <h3 style={{"margin-top":"40px"}}>People - Next cycle</h3> */}
                <DynamicForm
                    items={fieldDefs}
                    onSubmit={data => this.store.savePeopleInfo(data)}
                    submitButtonText={'Save and Next'}
                    submitButtonProps={{loading: this.store.formLoading}}
                />
            </TabPane>
        );
    };
    scheduleFormUpdate() {
        const data = this.store
        data.updatedate = true;
       return true;
    }
    saveUpdate=(data)=>{
    
    }
   
    
        onFinish = values => {
          console.log('Received values of form: ', values);
        };
         onChangeWorkflow=(value)=>{
            console.log('selected ${value}');
          }
          onChangeTask=(value)=>{

          }


          handleSubmitSchedule = e => {
            const utility = this.store;
            e.preventDefault();
            this.props.form.validateFields((err, values) => {
              if (!err) {
                utility.savePeopleInfo(values);
              }
            });
          };      

    renderScheduleForm = () => {
        const data = this.store.looseLeafSeed;
        
        // const updatedatekey = this.store;
        // const {schedulefieldDefs} = this.state;
        // schedulefieldDefs[0].defaultValue = data.globalWorkflowId;
        // schedulefieldDefs[1].defaultValue = data.recyclePeriod;
        // schedulefieldDefs[2].defaultValue = data.projectStartDate;
        // schedulefieldDefs[3].defaultValue = data.filesToAuthorDate;
        // schedulefieldDefs[4].defaultValue = data.filesFromAuthorDate;
        // schedulefieldDefs[5].defaultValue = data.ifpDate;
        // schedulefieldDefs[6].defaultValue = data.cmpDate;
        return (
         
        <TabPane tab={'Schedule'} key={"2"} disabled={!data.id}>
            <LooseLeafSchedulerDrawer dataStore={data}></LooseLeafSchedulerDrawer>


                    {/* <DynamicForm
                        items={schedulefieldDefs}
                        onSubmit={data => this.store.savePeopleInfo(data)}
                        submitButtonText={'Update'}
                        submitButtonStyle={{"margin-right":"200px"}}
                        submitButtonProps={{loading: this.store.formLoading}}
                    />
                    <Button style={{"float":"right","margin-top":"-32px","margin-right":"86px","color":"#fff","background-color":"green","border-color":"green"}} type="success" onClick={() => this.store.saveScheduleInfo(data)}>Finalize</Button> */}
            </TabPane>
        );
    }
   
}

LooseLeafDrawer.propTypes = {
    visible: PropTypes.bool
};

export default LooseLeafDrawer
